// extracted by mini-css-extract-plugin
export default {"headerMenu":"AppLayout_headerMenu__jLRB5","main":"AppLayout_main__mE1Ya","footer":"AppLayout_footer__N3iCu","AppLayout":"AppLayout_AppLayout__aEtFZ"};